<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("change_password") }}</template>
		</core-layout-headline-and-actions>

		<!-- Form -->
		<j-card class="xs-12 bg5 r2 p4">
			<!-- Current Password -->
			<core-form-input
				componentName="j-base-input-password"
				name="currentPassword"
				:label="$t('login.current_password')"
				v-validate="'required'"
				v-model="form.currentPassword"
				:validationErrors="errors"
			/>
			<!-- New password -->
			<core-form-input
				class="mt6"
				componentName="j-base-input-password"
				name="newPassword"
				:label="$t('login.new_password')"
				v-validate="'required'"
				v-model="form.newPassword"
				:validationErrors="errors"
			/>

			<!-- Password Rules -->
			<crm-password-rules :passwordRules="passwordRules" />

			<!-- Buttons -->
			<div class="mt6">
				<j-button class="secondary" @click="goBack">{{ $t("back") }}</j-button>
				<j-button
					:isLoading="isLoading"
					@click="handleSubmit"
					action="submit"
					class="ml3"
					>{{ $t("change_password") }}</j-button
				>
			</div>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard"
import JButton from "@/components/JButton"
import CrmPasswordRules from "@/components/CrmPasswordRules"
import api from "../api/"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreFormInput,
		JCard,
		JButton,
		CrmPasswordRules
	},

	data() {
		return {
			isLoading: false,
			form: {
				currentPassword: null,
				newPassword: null
			},
			passwordRules: null
		}
	},

	methods: {
		goBack() {
			this.$router.back()
		},
		async handleSubmit() {
			this.isLoading = true

			this.$validator.validate().then(async isValid => {
				if (isValid) {
					const res = await api.changePassword({
						changePasswordInput: {
							currentPassword: this.form.currentPassword,
							newPassword: this.form.newPassword
						}
					})

					this.isLoading = false

					if (res.errors) {
						const errorMsg = res.errors[0]?.split("|")[1]?.trim()
						this.$store.dispatch("showError", errorMsg || res.errors)
						return
					}

					this.$router.push({ name: "AuthAccount" })

					this.$store.dispatch("addMessage", {
						message: {
							type: "success",
							text: this.$t("success")
						}
					})
				} else {
					this.isLoading = false
				}
			})
		}
	},
	async mounted() {
		this.passwordRules = await this.$store.dispatch(
			"auth/getPasswordValidators",
			this.$store.state.tenantId
		)
	}
}
</script>
